import { useEffect, useState } from "react";
import { useRenewalsByQuarter } from "../../hook/partner/renewals.partner.hook";
import { useAuthStore } from "../../store/auth.store";
import { useRenewalsStore } from "../../store/renewals.store";
import RenewalOfferModal from "../../components/modals/renewal/RenewalOfferModal";
import { Accordion } from "react-bootstrap";
import CompanyDetailModal from "../../components/modals/company/CompanyDetailModal";

export default function RenewalsByQuarter(filter) {
  const renewalsMutation = useRenewalsByQuarter();
  const [page, setPage] = useState(0);
  const [openDetail, setOpenDetail] = useState(0);

  const [showModal, setShowModal] = useState(false);

  const [companyId, setCompanyId] = useState(false);

  const token = useAuthStore((state) => state.token);
  const renewals = useRenewalsStore((state) => state.renewalsByQuarter);
  const clearRenewals = useRenewalsStore((state) => state.clearRenewals);

  const quarters = [];
  const year = new Date().getFullYear();
  for (let i = year; i < year + 2; i++) {
    // - 1
    for (let j = 1; j < 5; j++) {
      quarters.push(i + "-" + "Q" + j);
    }
  }

  useEffect(() => {
    clearRenewals();
    setPage(quarters[0]);
  }, []);

  useEffect(() => {
    if (page !== 0) {
      renewalsMutation.mutate({ quarter: page, token, filter });
    }
  }, [page, token, filter]);

  return (
    <>
      <CompanyDetailModal
        company_id={companyId}
        onHide={() => setCompanyId(false)}
      />
      <ul className="mb-5 nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold d-none">
        {quarters.map((quarter, qindex) => (
          <li className="nav-item" key={qindex}>
            <span
              onClick={() => setPage(quarter)}
              className={
                "cursor-pointer nav-link" + (page == quarter ? " active" : "")
              }
              aria-current="page"
            ></span>
          </li>
        ))}
      </ul>
      <Accordion className="d-md-none" defaultActiveKey={0}>
        {quarters.map((quarter, qindex) => (
          <Accordion.Item eventKey={qindex} key={quarter}>
            <Accordion.Header onClick={() => setPage(quarter)}>
              {quarter}
            </Accordion.Header>
            <Accordion.Body style={{ padding: "2px" }}>
              {renewalsMutation.isLoading ? (
                <div className="alert alert-info">Nahrávání dat...</div>
              ) : (
                <Accordion>
                  {renewals?.list?.map((renewal, rindex) => (
                    <Accordion.Item eventKey={rindex} key={rindex}>
                      <Accordion.Header>
                        {renewal.name}{" "}
                        <span className="ms-3 badge badge-info badge-outline">
                          {new Date(renewal.expire_date).toLocaleDateString()}
                        </span>
                        <span
                          className={
                            "ms-3 me-2 badge badge-" +
                            (renewal.quantity_renewal == 0
                              ? "primary"
                              : renewal.quantity ==
                                renewal.quantity_renewal_done
                              ? "success"
                              : renewal.quantity ==
                                renewal.quantity_renewal_lost
                              ? "danger"
                              : "warning")
                          }
                        >
                          {renewal.quantity}
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row">
                          <div className="col-6 mb-3">
                            <span className="badge badge-success">
                              <strong>{renewal.vendor}</strong>
                            </span>
                          </div>
                          <div className="col-6 mb-3">
                            <strong>Celkem</strong>
                            <div>{renewal.quantity}</div>
                          </div>
                          <div className="col-6 mb-3">
                            <strong>Čeká na obnovu</strong>
                            <div>
                              {renewal.quantity - renewal.quantity_renewal >
                              0 ? (
                                <span class="badge badge-danger">
                                  {renewal.quantity - renewal.quantity_renewal}
                                </span>
                              ) : (
                                renewal.quantity - renewal.quantity_renewal
                              )}
                            </div>
                          </div>
                          <div className="col-6 mb-3">
                            <strong>V řešení</strong>
                            <div>
                              {renewal.quantity_renewal == 0 ? (
                                <span class="badge badge-primary">
                                  {renewal.quantity_renewal}
                                </span>
                              ) : (
                                renewal.quantity_renewal
                              )}
                            </div>
                          </div>
                          <div className="col-6 mb-3">
                            <strong>Obnovujeme</strong>
                            <div>
                              {renewal.quantity_renewal_progress > 0 ? (
                                <span class="badge badge-warning">
                                  {renewal.quantity_renewal_progress}
                                </span>
                              ) : (
                                renewal.quantity_renewal_progress
                              )}
                            </div>
                          </div>
                          <div className="col-6 mb-3">
                            <strong>Bez obnovy</strong>
                            <div>
                              {renewal.quantity_renewal_lost > 0 ? (
                                <span class="badge badge-danger">
                                  {renewal.quantity_renewal_lost}
                                </span>
                              ) : (
                                renewal.quantity_renewal_lost
                              )}
                            </div>
                          </div>
                        </div>
                        <button
                          className="btn btn-primary w-100 btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#renewal-offer-modal"
                          onClick={() => setOpenDetail(renewal)}
                        >
                          Detail
                        </button>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}{" "}
                </Accordion>
              )}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

      <div className="d-none d-md-block">
        {renewalsMutation.isLoading ? (
          <p>Načítání</p>
        ) : (
          <>
            <ul className="mb-5 nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
              {quarters.map((quarter, qindex) => (
                <li className="nav-item" key={qindex}>
                  <span
                    onClick={() => setPage(quarter)}
                    className={
                      "cursor-pointer nav-link" +
                      (page == quarter ? " active" : "")
                    }
                    aria-current="page"
                  >
                    {quarter}
                  </span>
                </li>
              ))}
            </ul>
            {!renewals ||
            renewals?.list?.length === 0 ||
            renewals.quarter != page ? (
              <div className="alert alert-danger">Nice nebylo nalezeno...</div>
            ) : (
              <div className="dt-container dt-bootstrap5 dt-empty-footer">
                <div id="" className="table-responsive">
                  <table
                    className="table align-middle table-bordered fs-6 gy-5 xxxdataTable"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr className="text-start align-middle text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                        <th rowSpan="2">Zákazník</th>
                        <th rowSpan="2">Výrobce</th>
                        <th rowSpan="2">Datum expirace</th>
                        <th colSpan="5">Počet licencí</th>
                        <th rowSpan="2"></th>
                      </tr>
                      <tr className="text-start align-middle text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                        <th>Celkem</th>
                        <th>Čeká na obnovu</th>
                        <th>V řešení</th>
                        <th>Obnovujeme</th>
                        <th>
                          Nebudeme
                          <br />
                          obnovovat
                        </th>
                      </tr>
                    </thead>
                    <tbody className="fw-semibold text-gray-600">
                      {renewals.list.map((renewal, rindex) => (
                        <tr key={rindex}>
                          <td>
                            <a
                              href={"/klient/" + renewal.company_id}
                              onClick={(e) => {
                                e.preventDefault();
                                setCompanyId(renewal.company_id);
                              }}
                            >
                              {renewal.name}
                            </a>
                          </td>
                          <td>{renewal.vendor}</td>
                          <td>
                            {new Date(renewal.expire_date).toLocaleDateString()}
                          </td>
                          <td>{renewal.quantity}</td>
                          <td>
                            {renewal.quantity - renewal.quantity_renewal > 0 ? (
                              <span class="badge badge-danger">
                                {renewal.quantity - renewal.quantity_renewal}
                              </span>
                            ) : (
                              renewal.quantity - renewal.quantity_renewal
                            )}
                          </td>
                          <td>
                            {renewal.quantity_renewal < renewal.quantity ? (
                              <span class="badge badge-primary">
                                {renewal.quantity_renewal}
                              </span>
                            ) : (
                              renewal.quantity_renewal
                            )}
                          </td>
                          <td>
                            {renewal.quantity_renewal_progress > 0 ? (
                              <span class="badge badge-warning">
                                {renewal.quantity_renewal_progress}
                              </span>
                            ) : (
                              renewal.quantity_renewal_progress
                            )}
                          </td>
                          <td>
                            {renewal.quantity_renewal_lost > 0 ? (
                              <span class="badge badge-secondary">
                                {renewal.quantity_renewal_lost}
                              </span>
                            ) : (
                              renewal.quantity_renewal_lost
                            )}
                          </td>
                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                setShowModal(true);
                                setOpenDetail(renewal);
                              }}
                            >
                              Detail
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <RenewalOfferModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        renewal={openDetail}
        title={openDetail?.name + " / " + openDetail?.vendor}
      />
    </>
  );
}
